import Query from "../../core/query/query";
export class OrderQuery extends Query {
    // transform() {
        
    // }
}